import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {Buffer} from 'buffer';

// RxJS
import {
    AppState,
    UPDATE_CONTENT,
    ADD_APP_ID,
    ADD_APPLICATION_ID,
    UPDATE_PERSONA
} from '../app-reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// pop up
import { FindApplicationDisclosureComponent } from './find-application.disclosure.component';
import { MatDialog } from '@angular/material/dialog';
import { PendingBlocksAlertComponent } from './pending-blocks-alert.component';

// animations
import { animate, style, transition, trigger } from '@angular/animations';

// services
import { QuestionService } from '../services/question.service';
import { ApiService } from 'src/app/services/api.service';
import { NavigationService } from '../services/navigation.service';
import { ComposableService } from '../services/composable.service';

// utilities
import { first } from 'rxjs/operators';
import { find, get, isEmpty } from 'lodash';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'find-application.component',
    templateUrl: './find-application.component.html',
    styleUrls: [],
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({ height: 0, opacity: 0 }),
                        animate('1s ease-out',
                            style({ height: 300, opacity: 1 }))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({ height: 300, opacity: 1 }),
                        animate('1s ease-in',
                            style({ height: 0, opacity: 0 }))
                    ]
                )
            ]
        )
    ]
})
export class FindApplicationComponent implements OnInit {

  constructor(
    private newRelicService: NewRelicService,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private store: Store<AppState>,
    private disclosure: MatDialog,
    private navigationService: NavigationService,
    private composableService: ComposableService,
    private router: Router,
    public service: QuestionService,
    private changeDetection: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.findApplicationFormGroup = this.formBuilder.group({
      lastName: ['', Validators.required],
      ssn: ['', Validators.compose([Validators.required, Validators.minLength(11), Validators.maxLength(11)])],
      zip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
      dob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
      consentCheckBox: ['', Validators.required]
    });

    this.appState$ = this.store.select('sections');

    // update store
    this.store.dispatch({
      type: UPDATE_PERSONA,
      payload: {
        name: 'InsuredNotOwner',
        id: 2.2
      }
    });

  }

  public pageGuard: boolean;
  public findApplicationFormGroup: FormGroup;
  appState$: Observable<any>;
  unauthenticated = false;
  timeOutFlag = false;
  processing = false;
  maxAttempts = 2;
  error = false;
  lastName = '';
  ss: number;
  ssnType: any = 'text';
  zip: number;
  dob = '';
  electronicConsent = false;
  maskSs: any = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskEin: any = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  maskZip: any = [/\d/, /\d/, /\d/, /\d/, /\d/];
  maskDob: any = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  errorMsg = 'You\'ve exceeded the number of attempts. Please contact your insurance agent for assistance.';
  ownerType = '';
  insuredLastName = '';
  ownerLastName = '';
  ownerSs: number;
  ownerZip: number;
  ownerDob: '';
  signatorTaxId: number;
  signatorLastName = '';
  signatorSsn: number;
  signatorZip = '';
  signatorDob = '';
  trusteeEin: number;
  trusteeZip= '';
  trusteeDob='';
  trusteeSsn: number;
  trusteeLastName = '';
  brokerageEApp = 'Brokerage E-App';
  stateOfIssue:any;
  appId: string;

  ngOnInit() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;

      this.newRelicService.addPageAction('find-app ngOnInit', { status: 'started', appId: this.appId });
    });

    // reset app state
    this.composableService.resetApplication();

  

    const url = new URL(location.href);
    this.commonService.logMessage('href: ', location.href);
    this.commonService.logMessage('app id: ', url.searchParams.get('AppId'));
    this.commonService.logMessage('owner type: ', url.searchParams.get('OwnerType'));
    this.ownerType = url.searchParams.get('OwnerType') ? url.searchParams.get('OwnerType') : null;
    if(url.searchParams.has('stateOfIssue'))
    {
      this.stateOfIssue=url.searchParams.get('stateOfIssue');
    }
    else
    {
      this.stateOfIssue="";
    }
    if (this.ownerType){
      // update store
      if (this.ownerType=='IndividualOwner'){
        this.findApplicationFormGroup = this.formBuilder.group({
          insuredLastName: ['', Validators.required],
          ownerLastName: ['', Validators.required],
          ownerSsn: ['', Validators.compose([Validators.required, Validators.minLength(11), Validators.maxLength(11)])],
          ownerZip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
          ownerDob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
          consentCheckBox: ['', Validators.required]
        });
      } else if (this.ownerType=='BusinessSignator'){
        this.findApplicationFormGroup = this.formBuilder.group({
          insuredLastName: ['', Validators.required],
          signatorLastName: ['', Validators.required],
          signatorTaxId: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
          signatorZip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
          signatorDob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
          consentCheckBox: ['', Validators.required]
        });
      } else if (this.ownerType=='EntityTrustee'){
        this.findApplicationFormGroup = this.formBuilder.group({
          insuredLastName: ['', Validators.required],
          signatorLastName: ['', Validators.required],
          trusteeEin: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
          signatorDob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
          trusteeZip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
          consentCheckBox: ['', Validators.required]
        });
      } else if (this.ownerType=='IndividualTrustee'){
        this.findApplicationFormGroup = this.formBuilder.group({
          insuredLastName: ['', Validators.required],
          trusteeLastName: ['', Validators.required],
          trusteeSsn: ['', Validators.compose([Validators.required, Validators.minLength(11), Validators.maxLength(11)])],
          trusteeDob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
          trusteeZip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
          consentCheckBox: ['', Validators.required]
        });
      } else if (this.ownerType=='Other'){
        this.findApplicationFormGroup = this.formBuilder.group({
          insuredLastName: ['', Validators.required],
          signatorLastName: ['', Validators.required],
          signatorTaxId: ['', Validators.compose([Validators.required])],
          signatorDob: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
          signatorZip: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
          consentCheckBox: ['', Validators.required]
        });
      }
    }
  }

  formatDOB(dob) {
    const temp = dob.replace(/[.*+?^${}/()|[]/g, '');
    const beginning = temp.slice(4, 8);
    const middle = temp.slice(0, 2);
    const end = temp.slice(2, 4);
    const formattedDOB = beginning + '-' + middle + '-' + end;

    return formattedDOB;
  }

  formatSSN(ssn) {
    return ssn.replace(/-/g, '');
  }

  onCheckboxChange() {
    this.electronicConsent = !this.electronicConsent;
  }

  consentLinkClick(event) {
    event.preventDefault();
    this.disclosure.open(FindApplicationDisclosureComponent,{
      data: {
        'stateOfIssue': this.stateOfIssue
      }
    });
  }

  

  onSubmit() {
    this.newRelicService.addPageAction('find-app onSubmit Start', { status: 'started', appId: this.appId });

    
      this.processing = true;

      // scrolls to top so
      // proposed insured sees message easily
      this.scrollToTop();

      // start finding application
      if (this.electronicConsent) {
        // format dob and ssn

        const payload = this.setPayload();


        // reset unauthenticated message
        this.unauthenticated = false;

        this.apiService.findApplication(payload).subscribe(response => {
            if (response.code === 200 && response.data) {
              this.unauthenticated = false;
              const resumePayload = {...response.data};
              this.setRole(response.data.SigningRole);
              this.dbResumeApplication(resumePayload);
            } else {
              console.log('Application with the specified credentials not found...');

              this.unauthenticated = true;
              this.processing = false;

              this.resetForm();
              this.exceededAttempts();

            }
          },
          (error) => {
            console.log('ERROR - Find Application Exception');
            console.log(error);
            this.unauthenticated = true;
            this.processing = false;
            this.resetForm();
            this.exceededAttempts();
          });
      }
    

    this.newRelicService.addPageAction('find-app onSubmit End', { status: 'completed', appId: this.appId });
  }


  setRole(SigningRole: any) {
    const roleStages = new Map([
      ["InsuredOwner", 2.1],
      ["InsuredNotOwner", 2.2],
      [ "OwnerA", 3 ],
      [ "OwnerB", 4 ],
      [ "OwnerC", 5 ],
      [ "OwnerD", 6 ],
      [ "OwnerE", 7 ],
      [ "OwnerF", 8 ],
      [ "OwnerG", 9 ],
      [ "OwnerH", 10 ],
      [ "OwnerI", 11 ],
      [ "OwnerJ", 12 ]
  ]);
    this.commonService.logMessage('signing role', SigningRole);
    if ((SigningRole.includes('Owner') || SigningRole.includes('Other')) && !SigningRole.includes('Insured')){
      this.store.dispatch({
        type: UPDATE_PERSONA,
        payload: {
          name: SigningRole,
          id: roleStages.get(SigningRole),
          customerSigned: 1 //if it's an owner, the PI already signed
          }
      });
    } else if (roleStages.get(SigningRole)){ //insured roles
      this.store.dispatch({
        type: UPDATE_PERSONA,
        payload: {
          name: SigningRole,
          id: roleStages.get(SigningRole),
          }
      });
    }
  }

  dbResumeApplication(resumePayload) {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;
  
      try {
        this.newRelicService.addPageAction('dbResumeApplication Start', { status: 'started', appId: this.appId });
  
        this.apiService.dbResumeApplication(resumePayload).subscribe(response => {
          if (response.code === 200 && response.data) {
            this.newRelicService.addPageAction('API Call Success', { status: 'success', appId: this.appId });
  
            let resumeAppObj = {
              ...response.data
            };
  
          // TODO handle pending jobs
            // if there are any pending jobs/blocks in the queue wait until it finishes
            if (response.data.PendingJobs) {
              this.newRelicService.addPageAction('Pending Jobs Handling', { status: 'pending jobs', appId: this.appId });
  
              const modalRef = this.disclosure.open(PendingBlocksAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: {
                  resumePayload,
                  PendingJobs: response.data.PendingJobs
                }
              });
              this.processing = false;
              this.changeDetection.detectChanges();
  
              modalRef.afterClosed().subscribe(checkResult => {
                this.newRelicService.addPageAction('Modal Close Handling', { status: 'modal closed', appId: this.appId });
  
                resumeAppObj = {...checkResult.data};
                this.continueWithTheApplication(checkResult, resumeAppObj);
              });
              return false;
            }
  
            this.newRelicService.addPageAction('Application Continuation', { status: 'continuing application', appId: this.appId });
  
            this.continueWithTheApplication(response, resumeAppObj);
            this.checkIfDemoApplication(response);
          } else {
            this.newRelicService.addPageAction('API Call Failure', { status: 'failure', appId: this.appId });
  
            console.log('Failure to resume application');
            this.processing = false;
            this.changeDetection.detectChanges();
          }
        }, (error) => {
          this.newRelicService.noticeError(error, { appId: this.appId });
  
          console.log('ERROR');
          console.log(error);
          // this.loadingAgentApplications = false;
          this.processing = false;
          this.changeDetection.detectChanges();
        });
      } catch (e) {
        this.newRelicService.noticeError(e, { appId: this.appId });
  
        console.log('ERROR - Resume Application exception caught');
        console.log(e);
        this.unauthenticated = true;
        this.processing = false;
        this.resetForm();
      }
    });
  }

  resumeApplication(resumePayload) {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;
  
      try {
        this.newRelicService.addPageAction('resumeApplication Start', { status: 'started', appId: this.appId });
  
        this.apiService.resumeApplication(resumePayload).subscribe(response => {
          if (response.code === 200 && response.data) {
            this.newRelicService.addPageAction('API Call Success', { status: 'success', appId: this.appId });
  
            let resumeAppObj = {
              ...response.data
            };
  
            // if there are any pending jobs/blocks in the queue wait until it finishes
            if (response.data.PendingJobs) {
              this.newRelicService.addPageAction('Pending Jobs Handling', { status: 'pending jobs', appId: this.appId });
  
              const modalRef = this.disclosure.open(PendingBlocksAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: {
                  resumePayload,
                  PendingJobs: response.data.PendingJobs
                }
              });
              this.processing = false;
              this.changeDetection.detectChanges();
  
              modalRef.afterClosed().subscribe(checkResult => {
                this.newRelicService.addPageAction('Modal Close Handling', { status: 'modal closed', appId: this.appId });
  
                resumeAppObj = {...checkResult.data};
                this.continueWithTheApplication(checkResult, resumeAppObj);
              });
              return false;
            }
  
            this.newRelicService.addPageAction('Application Continuation', { status: 'continuing application', appId: this.appId });
  
            this.continueWithTheApplication(response, resumeAppObj);
            this.checkIfDemoApplication(response);
          } else {
            this.newRelicService.addPageAction('API Call Failure', { status: 'failure', appId: this.appId });
  
            console.log('Failure to resume application');
            this.processing = false;
            this.changeDetection.detectChanges();
          }
        }, (error) => {
          this.newRelicService.noticeError(error, { appId: this.appId });
  
          console.log('ERROR');
          console.log(error);
          this.processing = false;
          this.changeDetection.detectChanges();
        });
      } catch (e) {
        this.newRelicService.noticeError(e, { appId: this.appId });
  
        console.log('ERROR - Resume Application exception caught');
        console.log(e);
        this.unauthenticated = true;
        this.processing = false;
        this.resetForm();
      }
    });
  }

  checkIfDemoApplication(response: any) {
    const appId = get(response, 'data.ApplicationId');
    const payload = {
      'appId': appId
    };
    this.apiService.isDemoApplication(payload).subscribe((resp) => {
      if (resp){
        this.appState$.pipe(first()).subscribe((state: any) => {
          state.isDemo = true;
          this.commonService.logAppState(state);
        });
      }
    });
  }



  continueWithTheApplication(response: any, resumeAppObj: any) {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;
  
      try {
        this.newRelicService.addPageAction('continueWithTheApplication Start', { status: 'started', appId: this.appId });
  
        // raw payload
        const rawPayload = resumeAppObj.EAppRawPayload;
        this.newRelicService.addPageAction('Raw Payload Parsing', { status: 'parsing', appId: this.appId });
  
        const payload = rawPayload ? window['JSON'].parse((Buffer.from(rawPayload, 'base64')).toString()) : this.service.generateRawPayload(resumeAppObj.QuestionBlocks, resumeAppObj.QuestionBlockResponses);
        
        // if empty redirect to error page
        if (!rawPayload && isEmpty(payload)) {
          this.newRelicService.addPageAction('Empty Payload Check', { status: 'empty payload', appId: this.appId });
          this.goToBlankApplicationLoadedErrorPage();
        } else {
          // maps PrimaryResidence.State to StateOfIssue when the latter is absent to avoid breaking in-flight cases when StateOfIssue is added
          if (payload.SECTIONAProposedInsured && payload.SECTIONAProposedInsured.PrimaryResidence.State && !payload.SECTIONAProposedInsured.StateOfIssue) {
            this.newRelicService.addPageAction('State Mapping', { status: 'mapping state', appId: this.appId });
            payload.SECTIONAProposedInsured.StateOfIssue = payload.SECTIONAProposedInsured.PrimaryResidence.State;
          }
  
          // update store
          this.newRelicService.addPageAction('Store Update', { status: 'updating store', appId: this.appId });
          this.store.dispatch({
            type: ADD_APP_ID,
            payload: get(response, 'data.AppAuthId')
          });
          this.store.dispatch({
            type: ADD_APPLICATION_ID,
            payload: get(response, 'data.ApplicationId')
          });
          this.store.dispatch({
            type: UPDATE_CONTENT,
            payload: payload
          });
  
          // enter eApp
          this.newRelicService.addPageAction('Entering eApp', { status: 'entering eApp', appId: this.appId });
          this.goToEapp();
        }
  
        this.newRelicService.addPageAction('continueWithTheApplication End', { status: 'completed', appId: this.appId });
      } catch (error) {
        this.newRelicService.noticeError(error, { appId: this.appId });
        console.log('ERROR - Continue with the application exception caught');
        console.log(error);
      }
    });
  }

  // blank application error page
  goToBlankApplicationLoadedErrorPage() {
    // determine which section
    console.log('Blank application detected. Redirecting to the appropriate error page..');
    this.navigationService.nextSectionRelative('error-blank-application');

  }

  goToEapp(): void {
    this.appState$.pipe(first()).subscribe((state: any) => {
			if (state.questions) {
			  const routes = this.router.config;
			  const newRoutes = routes.map(item => {
				const { data } = item;
				if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
				  const questionBlocks = find(state.questions, { Name: data.blockName });
				  item.data.blockCategory = questionBlocks.BlockCategory || null;
				  item.data.blockHeading = questionBlocks.DisplayName || null;
				}
				return item;
			  });
        this.navigationService.buildNavStore(newRoutes);
			};
    });
    // determine which section
    console.log('Going to eApp');
    this.navigationService.nextSectionRelative('proposed-insured');
    // trigger observable holding block submissions until application pre-processing is done
    this.navigationService.readyToSubmit(true);
  }

  scrollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  private exceededAttempts() {
    if (this.maxAttempts === 0) {
      this.findApplicationFormGroup.disable();
      this.timeOutFlag = true;
      this.unauthenticated = true;

      return true;
    }
    this.maxAttempts--;

    return false;
  }

  resetForm() {
    console.log('Resetting form');

    this.findApplicationFormGroup.disable();

    if (this.maxAttempts !== -1) {
      this.findApplicationFormGroup.enable();
    } else {
      this.findApplicationFormGroup.disable();
    }
  }

  setPayload() {
    let payload = {}
          if (this.ownerType){
            if (this.ownerType=='IndividualOwner'){
              const ss = this.formatSSN(this.ownerSs);
              const dob = this.formatDOB(this.ownerDob);

              payload = {
                'appDefName': this.brokerageEApp,
                'role': 'IndividualOwner',
                'lastName': this.insuredLastName,
                'ownerLastName': this.ownerLastName,
                'ownerSSN': ss,
                'ownerDOB': dob,
                'ownerZip': this.ownerZip
              };
            } else if (this.ownerType=='BusinessSignator'){
              const ss = this.formatSSN(this.signatorTaxId);
              const dob = this.formatDOB(this.signatorDob);

              payload = {
                'appDefName': this.brokerageEApp,
                'role': 'BusinessSignator',
                'lastName': this.insuredLastName,
                'signatorLastName': this.signatorLastName,
                'signatorBusinessTaxId': ss,
                'signatorDOB': dob,
                'signatorBusinessZip': this.signatorZip
              };
            }else if (this.ownerType=='IndividualTrustee'){
              const ss = this.formatSSN(this.trusteeSsn);
              const dob = this.formatDOB(this.trusteeDob);

              payload = {
                'appDefName': this.brokerageEApp,
                'role': 'IndividualTrustee',
                'lastName': this.insuredLastName,
                'signatorLastName': this.trusteeLastName,
                'signatorSSN': ss,
                'signatorDOB': dob,
                'signatorZip': this.trusteeZip
              };
            }else if (this.ownerType=='EntityTrustee'){
              const ein = this.formatSSN(this.trusteeEin);
              const dob = this.formatDOB(this.signatorDob);

              payload = {
                'appDefName': this.brokerageEApp,
                'role': 'EntityTrustee',
                'lastName': this.insuredLastName,
                'signatorLastName': this.signatorLastName,
                'entityTrusteeTaxId': ein,
                'signatorDOB': dob,
                'entityTrusteeZip': this.trusteeZip
              };
            } else if (this.ownerType=='Other'){
              const ss = this.formatSSN(this.signatorTaxId);
              const dob = this.formatDOB(this.signatorDob);

              payload = {
                'appDefName': this.brokerageEApp,
                'role': 'Other',
                'lastName': this.insuredLastName,
                'signatorLastName': this.signatorLastName,
                'signatorBusinessTaxId': ss,
                'signatorDOB': dob,
                'signatorBusinessZip': this.signatorZip
              };
            }
          }else {
            const dob = this.formatDOB(this.dob);
            const ss = this.formatSSN(this.ss);
            payload = {
              'appDefName': this.brokerageEApp,
              'role': 'ProposedInsured',
              'roleID': 2,
              'lastName': this.lastName,
              'ss': ss,
              'zip': this.zip,
              'dob': dob
            };
          }

          return payload;
  }
}


